import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = { isLoading: false, data: {}, errors: [] };

export const getServices = createAsyncThunk('services/getServices', async (args, thunkApi) => {
  try {
    const { page = 1, size = 10, query = '', filter = JSON.stringify({}) } = args || {};
    const { data } = await axios.get(
      `/api/get_services?page=${page}&size=${size}&query=${query}&filter=${filter}`
    );
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const createService = createAsyncThunk('services/createService', async (args, thunkApi) => {
  try {
    const { data } = await axios.post('/api/create_service', args, {
      headers: { 'Content-Type': 'application/json', Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const updateService = createAsyncThunk('services/updateService', async (args, thunkApi) => {
  try {
    const { data } = await axios.put(`/api/update_service/${args._id}`, args, {
      headers: { 'Content-Type': 'application/json', Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

export const deleteService = createAsyncThunk('services/deleteService', async (args, thunkApi) => {
  try {
    const { data } = await axios.delete(`/api/delete_service/${args._id}`, {
      headers: { Authorization: thunkApi.getState().auth.token }
    });
    return thunkApi.fulfillWithValue(data);
  } catch (errors) {
    return thunkApi.rejectWithValue(
      errors.response?.status !== 400 ? { errors: [{ msg: 'something went wrong' }] } : errors.response.data
    );
  }
});

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  extraReducers: {
    [getServices.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [getServices.fulfilled]: (state, action) => { state.isLoading = false; state.data = action.payload; },
    [getServices.rejected]: (state, action) => { state.isLoading = false; state.data = {}; state.errors = action.payload.errors; },

    [createService.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [createService.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.data.itemsCount = (state.data.itemsCount || 0) + 1;
      if ((state.data.data?.length || 0) < 10) state.data.data = [...(state.data.data || []), action.payload.data];
    },
    [createService.rejected]: (state, action) => { state.isLoading = false; state.errors = action.payload.errors; },

    [updateService.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [updateService.fulfilled]: (state, action) => {
      state.isLoading = false;
      const idx = state.data.data?.findIndex(el => el._id === action.payload.data._id);
      if (idx !== undefined && idx >= 0) state.data.data[idx] = action.payload.data;
    },
    [updateService.rejected]: (state, action) => { state.isLoading = false; state.errors = action.payload.errors; },

    [deleteService.pending]: (state) => { state.isLoading = true; state.errors = []; },
    [deleteService.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.data.data = state.data.data?.filter(el => el._id !== action.payload.data._id);
      state.data.itemsCount = Math.max(0, (state.data.itemsCount || 1) - 1);
    },
    [deleteService.rejected]: (state, action) => { state.isLoading = false; state.errors = action.payload.errors; },
  }
});

export default servicesSlice.reducer;
